function initIconRowSlideshow() {
  const slideshows = document.querySelectorAll('.icon-row--mobile-slideshow');
  
  const createIndicators = (slideshow) => {
    let indicators = slideshow.parentNode.querySelector('.icon-row__indicators');
    if (!indicators) {
      indicators = document.createElement('div');
      indicators.className = 'icon-row__indicators';
      slideshow.parentNode.appendChild(indicators);
    }
    const slides = slideshow.querySelectorAll('.icon-row__icon');
    indicators.innerHTML = '';
    slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.className = 'icon-row__indicator';
      dot.addEventListener('click', () => {
        slideshow.scrollTo({ left: index * slideshow.clientWidth, behavior: 'smooth' });
      });
      indicators.appendChild(dot);
    });
  };

  const updateIndicators = (slideshow) => {
    const indicators = slideshow.parentNode.querySelector('.icon-row__indicators');
    if (!indicators) return;
    const dots = indicators.querySelectorAll('.icon-row__indicator');
    const index = Math.round(slideshow.scrollLeft / slideshow.clientWidth);
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  };

  const handleSlideshow = (slideshow) => {
    let isDown = false;
    let startX;
    let initialScrollLeft = 0;
    let initialSlideIndex = 0;
    let slideWidth = slideshow.clientWidth;
    const threshold = slideWidth * 0.05;

    const startDragging = (pageX) => {
      isDown = true;
      startX = pageX - slideshow.offsetLeft;
      initialScrollLeft = slideshow.scrollLeft;
      slideWidth = slideshow.clientWidth;
      initialSlideIndex = Math.round(initialScrollLeft / slideWidth);
      slideshow.classList.add('active');
    };

    const stopDragging = () => {
      isDown = false;
      slideshow.classList.remove('active');
      const delta = slideshow.scrollLeft - initialScrollLeft;
      let targetIndex = initialSlideIndex;
      if (Math.abs(delta) > threshold) {
        targetIndex = delta > 0 ? initialSlideIndex + 1 : initialSlideIndex - 1;
      }
      const totalSlides = slideshow.querySelectorAll('.icon-row__icon').length;
      if (targetIndex < 0) targetIndex = 0;
      if (targetIndex >= totalSlides) targetIndex = totalSlides - 1;
      slideshow.scrollTo({ left: targetIndex * slideWidth, behavior: 'smooth' });
      updateIndicators(slideshow);
    };

    const move = (pageX) => {
      if (!isDown) return;
      const x = pageX - slideshow.offsetLeft;
      const walk = (x - startX) * 2;
      slideshow.scrollLeft = initialScrollLeft - walk;
      updateIndicators(slideshow);
    };

    // Mouse events
    slideshow.addEventListener('mousedown', (e) => {
      e.preventDefault();
      startDragging(e.pageX);
    });
    slideshow.addEventListener('mousemove', (e) => {
      move(e.pageX);
    });
    slideshow.addEventListener('mouseup', stopDragging);
    slideshow.addEventListener('mouseleave', stopDragging);

    // Touch events
    slideshow.addEventListener('touchstart', (e) => {
      startDragging(e.touches[0].pageX);
    });
    slideshow.addEventListener('touchmove', (e) => {
      move(e.touches[0].pageX);
    });
    slideshow.addEventListener('touchend', stopDragging);
    
    slideshow.addEventListener('scroll', () => {
      updateIndicators(slideshow);
    });
  };

  slideshows.forEach(slideshow => {
    // Clean up existing event listeners by cloning the node
    const newSlideshow = slideshow.cloneNode(true);
    slideshow.parentNode.replaceChild(newSlideshow, slideshow);
    handleSlideshow(newSlideshow);
    createIndicators(newSlideshow);
    updateIndicators(newSlideshow);
  });
}

// Initialize with debounce
let initTimeout;
function debouncedInit() {
  clearTimeout(initTimeout);
  initTimeout = setTimeout(initIconRowSlideshow, 100);
}

// Event listeners
document.addEventListener('DOMContentLoaded', debouncedInit);
document.addEventListener('shopify:section:load', debouncedInit);
document.addEventListener('shopify:section:unload', debouncedInit);
document.addEventListener('shopify:block:select', debouncedInit);
